import { useGet } from "@ngt/opms";
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { GetServicesAustraliaConsentHistory, GetServicesAustraliaConsentHistoryResponse, Patient } from "../../api/dtos";


const getData = (response?: SWRResponse<GetServicesAustraliaConsentHistoryResponse, GetServicesAustraliaConsentHistoryResponse>) => response?.data?.consentHistory
const getError = (response?: SWRResponse<GetServicesAustraliaConsentHistoryResponse, GetServicesAustraliaConsentHistoryResponse>) => (response?.error ?? response?.data)?.responseStatus;

const useGetServicesAustraliaConsentHistory = (patient: Patient | undefined, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return patient ? 
            () => {
                return new GetServicesAustraliaConsentHistory({
                    patientId: patient.id
                })
            } : 
            undefined;
    }, [patient]);

    return useGet(request, { getData, getError }, configuration)
}

export default useGetServicesAustraliaConsentHistory;